import { render } from "./WCAddToListToast.vue?vue&type=template&id=3c66e2f2"
import script from "./WCAddToListToast.vue?vue&type=script&lang=js"
export * from "./WCAddToListToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__